var React = require('react');

function IconRepository (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M883.4 78.1c-3.9-8.2-14.5-14.9-23.6-14.9H155.5c-9.1 0-19.5 6.8-23.1 15.2l-69 159.2 36.9 704.6c.5 9.1 8.3 16.4 17.3 16.4h787.7c9.1 0 16.8-7.4 17.3-16.4l36.9-704.6-76.1-159.5zM417 511.8l-176.5 64.7L417 641.8c1.6.6 2.6 2.1 2.6 3.8v28.6c0 2.8-2.8 4.7-5.4 3.7l-218-83.1c-1.6-.6-2.6-2.1-2.6-3.7V562c0-1.7 1-3.2 2.6-3.7l218-82.5c2.6-1 5.4.9 5.4 3.7V508c0 1.7-1 3.2-2.6 3.8zm60.2 220.1h-25.4c-2.7 0-4.6-2.6-3.8-5.2l96.4-306.4c.5-1.7 2.1-2.8 3.8-2.8h25.7c2.7 0 4.6 2.6 3.8 5.2L481 729.1c-.5 1.7-2.1 2.8-3.8 2.8zm350.8-137L610 678c-2.6 1-5.4-.9-5.4-3.7v-28.6c0-1.7 1-3.2 2.6-3.8l176.5-65.3-176.5-64.7c-1.6-.6-2.6-2.1-2.6-3.8v-28.5c0-2.8 2.8-4.7 5.4-3.7l218 82.5c1.6.6 2.6 2.1 2.6 3.7v29.1c0 1.6-1 3.1-2.6 3.7zm31.8-366.1h-694c-9.1 0-14.1-7-11.2-15.7l26.8-80.5c2.9-8.7 12.5-15.7 21.7-15.7h609.2c9.1 0 19.4 6.8 22.9 15.2l34.6 81.5c3.6 8.4-.8 15.2-10 15.2z"}));
}

IconRepository.displayName = "IconRepository";

IconRepository.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconRepository;

IconRepository.default = IconRepository;
